import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowRight, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

function PaymentCancelled() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center"
      >
        <motion.div 
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", delay: 0.2 }}
          className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <XCircle className="w-10 h-10 text-amber-600" />
        </motion.div>
        
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Payment Cancelled</h1>
        <p className="text-slate-600 mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        
        <p className="text-sm text-slate-500 mb-6">
          Changed your mind? No worries! You can always come back when you are ready.
        </p>
        
        <div className="space-y-3">
          <Link to="/#pricing">
            <Button className="w-full bg-red-500 hover:bg-red-600">
              View Pricing Again <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full">
              <Home className="w-4 h-4 mr-2" /> Back to Home
            </Button>
          </Link>
        </div>
        
        <p className="text-xs text-slate-400 mt-6">
          Need help? Contact us at support@innovatorfoundervisas.com
        </p>
      </motion.div>
    </div>
  );
}

export default PaymentCancelled;
